// data-testid's
export const ADD_EMPLOYEES_SAVE_BTN = 'add-employees-save-btn';
export const EMAIL_INPUT_FIELD = 'email-input';
export const FULL_NAME_INPUT_FIELD = 'full-name-input';

// copy
export const ADD_EMPLOYEES_TEXT = 'Add employees';
export const FIRST_AND_LAST = 'First and last name';
export const LAST_NAME_REQUIRED_TEXT = 'Provide both a first and last name';
